import { Window } from "@progress/kendo-react-dialogs";
import useEventListener from "@use-it/event-listener";
import { useState } from "react";

export interface TrialTourProps {
  url: string;
  onClose: () => void;
}

const TrialTour = ({ props }: { props: TrialTourProps }) => {
  const { onClose, url } = props;
  const exitButton = document
    .getElementsByClassName(
      "k-button k-button-md k-button-flat k-button-flat-base k-rounded-md k-icon-button k-window-action"
    )
    .item(2);
  const [exitVisibility] = useState("hidden");
  if (exitVisibility === "visible") {
    exitButton?.setAttribute("style", `visibility: ${exitVisibility};`);
  }
  const listenForMessage = (ev) => {
    console.log("trial tour ev:", ev);
    if (ev.data === "TourComplete") {
      //setExitVisibility("visible");
    } else if (ev.data === "CloseTour") {
      onClose();
    }
  };

  useEventListener("message", listenForMessage);
  return (
    <>
      <Window
        modal
        draggable={false}
        resizable={false}
        className="trial-tour"
        // title="Product Tour"
        height={window.innerHeight}
        width={window.innerWidth}
        onClose={onClose}
        style={{ padding: "0", overflow: "hidden" }}
        overlayStyle={{ padding: "0", display: "relative" }}
      >
        <iframe
          title="Trial tour"
          name="trial-tour-iframe"
          height={window.innerHeight - 4}
          width={window.innerWidth - 3}
          className="flex grow"
          src={url}
          style={{ padding: "0", overflow: "hidden" }}
        />
      </Window>
    </>
  );
};

export default TrialTour;
